import { FormInputText } from '../text/element';
export class FormInputTel extends FormInputText {
    constructor() {
        super(...arguments);
        this.type = 'tel';
    }
}
if (!customElements.get('ep-form-input-tel')) {
    customElements.define('ep-form-input-tel', FormInputTel);
}
//# sourceMappingURL=element.js.map